import { FirestoreDataConverter, Timestamp } from 'firebase/firestore';
import { Entity } from './entity';
import { User } from './user';

export enum PartnerShipStatus {
  PENDING = 'Pending',
  ACCEPTED = 'Accepted',
  REJECTED = 'Rejected',
  ENDED = 'Ended',
}

export interface PartnershipBase extends Entity {
  status: PartnerShipStatus;
  createdAt: Date;
  enderId?: string;
}

export interface PartnershipRequest extends PartnershipBase {
  requesterId: string;
  responderId: string;
}

export interface Partnership extends PartnershipBase {
  isMyRequest: boolean;
  partner: User;
}

export interface FirestorePartnershipRequest extends Omit<PartnershipRequest, 'createdAt'> {
  createdAt: Timestamp;
}

export const PartnershipRequestConverter: FirestoreDataConverter<PartnershipRequest, FirestorePartnershipRequest> = {
  toFirestore: (partnership: PartnershipRequest): FirestorePartnershipRequest => {
    return {
      ...partnership,
      createdAt: Timestamp.fromDate(partnership.createdAt),
    };
  },
  fromFirestore: (snapshot, options): PartnershipRequest => {
    const partnership = snapshot.data(options) as FirestorePartnershipRequest;
    return {
      ...partnership,
      createdAt: partnership.createdAt.toDate(),
    };
  },
};

export const PartnershipCollection = 'partnerships';
